import React from "react";
import { create } from "zustand";

interface IModalStore {
  modal: React.ReactNode | null;
  isOpen: boolean;
  closeOnBackgroundClick: boolean;
  isSupportTabOpen: boolean;
  onCloseSideEffects: (() => void) | null;
  openModal: (args: {
    modal: React.ReactNode;
    closeOnBackgroundClick?: boolean;
    onCloseSideEffects?: (() => void) | null;
    isSupportTabOpen?: boolean;
  }) => void;
  closeModal: () => void;
}

const initialState = {
  modal: null,
  isOpen: false,
  closeOnBackgroundClick: true,
  onCloseSideEffects: null,
  isSupportTabOpen: false,
};

export const useModalStore = create<IModalStore>((set) => ({
  ...initialState,
  openModal: ({
    modal,
    closeOnBackgroundClick = true,
    onCloseSideEffects = null,
    isSupportTabOpen = false,
  }) => {
    set({
      modal,
      isOpen: true,
      closeOnBackgroundClick,
      onCloseSideEffects,
      isSupportTabOpen,
    });
  },
  closeModal: () => set(initialState),
}));
